export function supabase(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: supabase is not implemented yet.', args);
  return null;
}
